<template>
	<div class="percentage-wrapper">
		<div id="percent" ref="percentage" class="percentage" ></div>
	</div>
</template>

<script>
	import './scss/index.scss';

	const vueObject = {
		mounted: function() {
			const percentLabel = document.querySelector("#percent");

			window.addEventListener("scroll", () => {
				let scrollTop = window.scrollY;
				let docHeight = document.body.offsetHeight;
				let winHeight = window.innerHeight;
				let scrollPercent = scrollTop / (docHeight - winHeight);
				let scrollPercentRounded = Math.round(scrollPercent * 100);

				percentLabel.style.width = scrollPercentRounded + '%';
			});			
		}
	}

	export default vueObject;
</script>